


















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import CreateDeskRequest from '@/models/Desks/CreateDeskRequest';
import DeskDto from '@/models/Desks/DeskDto';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';

@Component({
    name: 'DeskCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new DeskDto();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new DeskDto();
    }
  }

  get businessHours() {
    return AgencySettingsModule.businessHours;
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new CreateDeskRequest();
    request.name = this.entity.name;
    request.businessHoursId = this.entity.businessHours.id;
       
    await AgencySettingsModule.createDesk(request)
    this.dialog = false;
  }
}
